import React, {useState, useEffect} from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import { Box, Grid, Typography } from '@mui/material';
import { useMediaQuery, useTheme } from '@mui/material';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import LanguageIcon from '@mui/icons-material/Language';
import ShareIcon from '@mui/icons-material/Share';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Modal from '@mui/material/Modal';

import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { enqueueSnackbar } from 'notistack';

import { setLanguage, setYoutubeVideo, showInviteFriend, showTermsOfUse, } from '../../store/slices/configSlice';
import { constants } from '../../util';
import { sendInvitationFriend } from "../../services/invitationService";

import { useSelector, useDispatch } from 'react-redux';
import { showWaiting } from '../../store/slices/configSlice';
import { getYoutubeVideo } from "../../services/utilService";


const schema = yup.object({
    nameSender: yup.string().required().min(3).max(40),
    nameFriend: yup.string().required().min(3).max(40),
    emailFriend: yup.string().email().required().min(6).max(40),
});


const Footer = () => {
    let location = useLocation();
    const [isMainPage, setIsMainPage] = useState(true);
    // const [version, setVersion] = useState('');
    const navigate = useNavigate();
    const {language, openInviteFriend, version} = useSelector( state => state.configuration);
    const dispatch = useDispatch();
    
    //TRANSLATION
    const [t, i18n] = useTranslation("global");

    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.down('sm'));
    const isMd = useMediaQuery(theme.breakpoints.down('md'));
    const isXl = useMediaQuery(theme.breakpoints.down('xl'));

    let slides = 4;
    if (isSm) slides = 1;
    else if (isMd) slides = 2;
    else if (isXl) slides = 3;
    

    const handleClickTerms = () => {
        dispatch(showTermsOfUse(true));
    }

    const handleClickTerms2 = (page) => {
        let url;
        switch(page){
            case 'serviceTerms':
                url = '/termsofuse';
                break;
            case 'privacyPolicy':
                url = '/privacypolicy';
                break;
            case 'endUserData':
                url = '/enduserdata';
                break;
        }
        window.open(url, '_blank', 'noopener,noreferrer');
    }


    const handleClickLanguge = () => {
        i18n.changeLanguage((language === 'es' ? 'en' : 'es'));
        window.localStorage.setItem('dl-lang', (language === 'es' ? 'en' : 'es'));
        dispatch(setLanguage((language === 'es' ? 'en' : 'es')));
        
        enqueueSnackbar(
            language === 'es' ? 'Language was successfully changed' : 'El idioma cambió correctamente'
            , { 
                variant: 'success',
                persist: false
            });
        
        // getYoutubeVideo()
        //     .then(rsp => {
        //         if (rsp.code === '00'){
        //             dispatch(setYoutubeVideo(rsp.metadata));
        //         }
        //     })
    }

    
    const handleClick_Navigate = (page) => {
        switch(page){
            case "home": 
                navigate("/");
                break;
            case "aboutus": 
                navigate("/aboutus");
                break;
            case "faq": 
                navigate("/faq");
                break;
            case "getintouch": 
                navigate("/getintouch");
                break;
        }
    }


    const handleClick_InviteFriend = () => {
        dispatch(showInviteFriend(true));
    }


    const handleClick_OpenSocial = (social) => {
        switch (social){
            case "tiktok":
                window.open("https://www.tiktok.com/@dlunamusic?_t=ZS-8yMH0Tzvsge&_r=1", "_blank")
                break;
            case "instagram":
                window.open("https://www.instagram.com/dlunamusica?igsh=MWVueGZodTV2d2pyNA==", "_blank")
                break;
            case "facebook":
                window.open("http://Facebook.com/dlunarecords", "_blank")
                break;
        }
    }


    const handleClick_InviteOk = () => {
        enqueueSnackbar(
            language === 'es' ? 'Thanks by sharing our site with your friends' : 'Gracias por compartir nuestro sitio Web con tus amigos'
            , { 
            variant: 'success',
            persist: false
        });
        dispatch(showInviteFriend(false));
    }


    const handleClick_InviteCancel = () => {
        onClose();
    }

    const onClose = () => {
        dispatch(showInviteFriend(false))
        reset();
    }



    const { control, register, handleSubmit, reset, setFocus, formState: { errors } } = useForm({
                resolver: yupResolver(schema)
            });
    
    const submitForm = (data) => {
        dispatch(showWaiting(true));
        
        sendInvitationFriend(data.nameSender, data.nameFriend, data.emailFriend)
            .then(rsp => {
                setTimeout(() => {
                    if (rsp.code === '00'){
                        dispatch(showInviteFriend(false));
                        reset();
                        enqueueSnackbar(rsp.message, { variant: 'success', persist: false });
                    }
                    else
                        enqueueSnackbar(rsp.message, { variant: 'error', persist: false });

                    dispatch(showWaiting(false));
                }, 1500);
            });
    }



    useEffect(() => {
        setIsMainPage(
            location.pathname==='/' ||
            location.pathname==='/home' ||
            location.pathname==='/aboutus' ||
            location.pathname==='/faq' ||
            location.pathname==='/getintouch'
        );
        
        // const REACT_APP_VERSION = import.meta.env.VITE_APP_VERSION;
        // setVersion(REACT_APP_VERSION);
    }, [location.pathname]);

    return (
        <>
        {
            isMainPage 
            ?
                <Box sx={{
                    margin:0,
                    height: {
                        sxs:'650px',
                        xs:'650px',
                        sm:'250px',
                        md:'250px',
                        lg:'250px',
                        xl:'250px',
                    },
                    width: '100%',
                    backgroundColor: '#000000',
                    position: 'relative',
                    display: 'flex',
                    alignItems:'center',
                    bottom:0
                }}>
                    <div style={{
                        margin: 0,
                        padding: 0,
                        border: 0,
                        width: '100%',
                        height: 110,
                        display: 'block', 
                        position: 'absolute',
                        backgroundImage: "url('/assets/img/generic/Roto2.svg')",
                        backgroundSize: 'cover',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'left',
                        bottom: slides === 1 ? 600 : 200,
                        zIndex: 15, 
                    }}></div>

                    <Grid container size={12} direction='row' sx={{width:'100%'}}>
                        <Grid size={{
                            sxs:12,
                            xs:12,
                            sm:4,
                            md:4,
                            lg:4,
                            xl:4,
                        }} sx={{
                            paddingLeft: slides > 1 ? '50px' : '0px',
                            textAlign: slides > 1 ? 'left' : 'center',
                        }}>
                            <img src='/assets/img/logo/logomain.jpg' style={{width:'45%'}} />
                            <div 
                                style={{display: 'flex',
                                justifyContent: slides > 1 ? 'flex-start' : 'center'
                            }}>
                                <Stack direction='row' spacing={0} sx={{ alignItems: 'left', width:'40%' }}>
                                    <IconButton aria-label="delete" sx={{width:'35%'}} onClick={()=>handleClick_OpenSocial("tiktok")}>
                                        <img src='/assets/img/logo/tiktok.png' style={{width:'100%'}} />
                                    </IconButton>
                                    <IconButton aria-label="delete" sx={{width:'35%'}} onClick={()=>handleClick_OpenSocial("instagram")}>
                                        <img src='/assets/img/logo/instagram.png' style={{width:'100%'}} />
                                    </IconButton>
                                    <IconButton aria-label="delete" sx={{width:'35%'}} onClick={()=>handleClick_OpenSocial("facebook")}>
                                        <img src='/assets/img/logo/facebook.png' style={{width:'100%'}} />
                                    </IconButton>
                                </Stack>
                            </div>
                            <div style={{color:'#FFF', width:'40%' , textAlign:'center', fontSize:'10px'}}>v{version}</div>
                        </Grid>
                        <Grid container direction='column' spacing={0} size={{
                            sxs:12,
                            xs:12,
                            sm:4,
                            md:4,
                            lg:4,
                            xl:4,
                        }} sx={{textAlign:'center', color:'white', display:'flex', justifyContent:'center'}}>
                            {slides===1 ? <br /> : null}
                            {slides===1 ? <br /> : null}
                            {/* {
                                slides <= 1 ? null :  */}
                                    {/* <div style={{backgroundColor:'red', width:'170px'}}> */}
                                        {slides===1 ? null : <Button variant="text" sx={{ ...constants.styles.linkButton, color:'white', fontSize: '13px' }} onClick={()=>handleClick_Navigate("home")}>{t("footer.menuStart")}</Button> }
                                        {slides===1 ? null : <Button variant="text" sx={{ ...constants.styles.linkButton, color:'white', fontSize: '13px' }} onClick={()=>handleClick_Navigate("aboutus")}>{t("footer.menuWhoWeAre")}</Button> }
                                        {slides===1 ? null : <Button variant="text" sx={{ ...constants.styles.linkButton, color:'white', fontSize: '13px' }} onClick={()=>handleClick_Navigate("faq")}>{t("footer.menuFAQ")}</Button> }
                                        {slides===1 ? null : <Button variant="text" sx={{ ...constants.styles.linkButton, color:'white', fontSize: '13px' }} onClick={()=>handleClick_Navigate("getintouch")}>{t("footer.menuContact")}</Button> }
                                        
                                    {/* </div> */}
                            {/* } */}
                            
                            {slides===1 ? <br /> : null}
                            {slides===1 ? <br /> : null}
                        </Grid>
                        <Grid size={{
                            sxs:12,
                            xs:12,
                            sm:4,
                            md:4,
                            lg:4,
                            xl:4,
                        }} sx={{paddingRight: slides>1 ? '50px' : '0px', textAlign: slides > 1 ? 'right' : 'center', display:'flex', justifyContent:slides > 1 ? 'right' : 'center'}}>
                            <div style={{display:'flex', alignItems:'center', flexDirection:'column'}}>
                                <Button onClick={()=>handleClickLanguge()} variant="contained" startIcon={<LanguageIcon />} sx={{textTransform:'none', marginBottom:'20px', color:'#000000', backgroundColor:'#ffffff'}}>
                                    {t("footer.btnLanguage")}
                                </Button>
                                <Button onClick={()=>handleClick_InviteFriend()} variant="text" startIcon={<ShareIcon />} sx={{color:'white', textTransform:'none'}}>
                                    {t("footer.btnShare")}
                                </Button>
                                <Button 
                                    component="label" 
                                    variant="text" 
                                    sx={{ ...constants.styles.linkButton, color:'white', textTransform:'none' }}
                                    onClick={()=>handleClickTerms2('serviceTerms')}
                                >
                                    {t("footer.serviceTerms")}
                                </Button>
                                <Button 
                                    component="label" 
                                    variant="text" 
                                    sx={{ ...constants.styles.linkButton, color:'white', textTransform:'none' }}
                                    onClick={()=>handleClickTerms2('privacyPolicy')}
                                >
                                    {t("footer.privacyPolicy")}
                                </Button>
                                {/* <Button 
                                    component="label" 
                                    variant="text" 
                                    sx={{ ...constants.styles.linkButton, color:'white', textTransform:'none' }}
                                    onClick={()=>handleClickTerms2('endUserData')}
                                >
                                    {t("footer.endUserData")}
                                </Button> */}
                                {/* <p className="text-regular" style={{fontSize:'12px', color:'white', textAlign:slides>1 ? 'right' : 'center'}}>
                                    {t("footer.addrLine1")} <br />
                                    {t("footer.addrLine2")} <br />
                                    {t("footer.addrLine3")}
                                </p> */}
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            :
                <Box sx={{
                    width:'100%',
                    // height:'40px',
                    display:'flex',
                    flexDirection:'row',
                    justifyContent:'space-between',
                }}>
                    <Typography sx={{fontSize:'11px', marginTop:{
                        sxs: '0px', 
                        xs: '0px',  // Cel-ular-vertical
                        sm: '6px',  // Ipad Vertical
                        md: '6px',  // Ipad Horizontal
                        lg: '6px',  // Laptop-PC
                        xl: '6px',  // Laptop-PC,
                    }}}>
                        ⓒ {t("footer.rigthsReserved")} - v{version}
                    </Typography>


                    {/* <Button 
                        component="label" 
                        variant="text" 
                        sx={{ ...constants.styles.linkButton, fontSize: '11px', position: 'relative' }}
                        onClick={()=>handleClickTerms()}
                    >
                        {t("footer.serviceTerms")}
                    </Button> */}
                    
                    {
                        location.pathname!=='/termsofuse' 
                        && location.pathname!=='/privacypolicy' 
                        && location.pathname!=='/enduserdata'
                            ?   <Button 
                                    component="label" 
                                    variant="text" 
                                    sx={{ ...constants.styles.linkButton, fontSize: '11px', position: 'relative' }}
                                    onClick={()=>handleClickTerms2('privacyPolicy')}
                                >
                                    {t("footer.privacyPolicy")}
                                </Button>
                            : null
                    }

                    <Button onClick={()=>handleClickLanguge()} variant="contained" startIcon={<LanguageIcon />} 
                        sx={{
                            height:'fit-content',
                            fontSize:'10px',
                            textTransform:'none', 
                            color:'#000000', 
                            backgroundColor:'#ffffff'}}>
                        {t("footer.btnLanguage")}
                    </Button>
                </Box>
        }
            
            
            <Modal
                open={openInviteFriend}
                onClose={()=>onClose()}
            >
                <Box sx={{ ...constants.styles.modalBox,
                    width: {
                        sxs: '95%', 
                        xs: '95%',  // Celular-vertical
                        sm: '80%',  // Ipad Vertical
                        md: '30%',  // Ipad Horizontal
                        lg: '65%',  // Laptop-PC
                        xl: '65%',  // Laptop-PC,
                    },
                    maxwidth: {
                        sxs: '400px', 
                        xs: '400px',  // Cel-ular-vertical
                        sm: '50vw',  // Ipad Vertical
                        md: '700px',  // Ipad Horizontal
                        lg: '700px',  // Laptop-PC
                        xl: '700px',  // Laptop-PC,
                    },
                    // height:  '95%',
                    // minHeight: '350px',
                    maxHeight: '520px',
                    padding: '20px',
                }}
                >
                    <div style={{marginBottom:'15px'}}>
                        {t("footer.inviteText")} 
                    </div>
                    <form onSubmit={handleSubmit(submitForm)}>
                        <TextField id="txtNameSender" label={t("footer.inviteTextField_sender")} variant="outlined" margin="dense" fullWidth sx={{...constants.styles.textfield, backgroundColor:'white', border:'1px solid #e1e1e1', marginBottom:'15px'}}  
                            {...register('nameSender')}
                            error={!!errors.nameSender}
                            helperText={errors.nameSender?.message}
                        />
                        <TextField id="txtNameFriend" label={t("footer.inviteTextField_friend")} variant="outlined" margin="dense" fullWidth sx={{...constants.styles.textfield, backgroundColor:'white', border:'1px solid #e1e1e1', marginBottom:'15px'}}
                            {...register('nameFriend')}
                            error={!!errors.nameFriend}
                            helperText={errors.nameFriend?.message}
                        />
                        <TextField id="txtEmail" label={t("footer.inviteTextField_email")} variant="outlined" margin="dense" fullWidth sx={{...constants.styles.textfield, backgroundColor:'white', border:'1px solid #e1e1e1', marginBottom:'15px'}}
                            {...register('emailFriend')}
                            error={!!errors.emailFriend}
                            helperText={errors.emailFriend?.message}
                        />
                        <div style={{
                            width:'100%',
                            display: 'flex',
                            justifyContent:'flex-end',
                            // textAlign:'right',
                        }}>
                            <Button type="submit" variant="text" sx={{ ...constants.styles.mainButton, width:'35%', marginRight:'8px' }}>{t("footer.inviteBtnOK")}</Button>
                            <Button onClick={()=>handleClick_InviteCancel()} variant="text" sx={{ ...constants.styles.secondaryButton, width:'35%' }}>{t("footer.inviteBtnCancel")}</Button>
                        </div>
                    </form>
                </Box>
            </Modal>
        </>
    )
}

export default Footer;